enum STAND_WORKSHEET_COLUMN_VIEW_EDIT {
  MANAGER_BEGIN_VIEW = 'manager_begin_view',
  MANAGER_BEGIN_EDIT = 'manager_begin_edit',
  GRATIS_VIEW = 'gratis_view',
  GRATIS_EDIT = 'gratis_edit',
  INGREDIENT_SPOIL_VIEW = 'ingredient_spoil_view',
  INGREDIENT_SPOIL_EDIT = 'ingredient_spoil_edit',
  END_VIEW = 'end_view',
  END_EDIT = 'end_edit',
  ADJUSTMENT_VIEW = 'adjustment_view',
  ADJUSTMENT_EDIT = 'adjustment_edit',
}

export const STAND_WORKSHEET_COLUMN_VIEW_ARR = [
  STAND_WORKSHEET_COLUMN_VIEW_EDIT.MANAGER_BEGIN_VIEW,
  STAND_WORKSHEET_COLUMN_VIEW_EDIT.GRATIS_VIEW,
  STAND_WORKSHEET_COLUMN_VIEW_EDIT.INGREDIENT_SPOIL_VIEW,
  STAND_WORKSHEET_COLUMN_VIEW_EDIT.END_VIEW,
  STAND_WORKSHEET_COLUMN_VIEW_EDIT.ADJUSTMENT_VIEW,
];

export const STAND_WORKSHEET_COLUMN_EDIT_ARR = [
  STAND_WORKSHEET_COLUMN_VIEW_EDIT.MANAGER_BEGIN_EDIT,
  STAND_WORKSHEET_COLUMN_VIEW_EDIT.GRATIS_EDIT,
  STAND_WORKSHEET_COLUMN_VIEW_EDIT.INGREDIENT_SPOIL_EDIT,
  STAND_WORKSHEET_COLUMN_VIEW_EDIT.END_EDIT,
  STAND_WORKSHEET_COLUMN_VIEW_EDIT.ADJUSTMENT_EDIT,
];

export const STAND_WORKSHEET_COLUMN_VIEW_EDIT_MAPPING = {
  [STAND_WORKSHEET_COLUMN_VIEW_EDIT.MANAGER_BEGIN_VIEW]:
    STAND_WORKSHEET_COLUMN_VIEW_EDIT.MANAGER_BEGIN_EDIT,
  [STAND_WORKSHEET_COLUMN_VIEW_EDIT.MANAGER_BEGIN_EDIT]:
    STAND_WORKSHEET_COLUMN_VIEW_EDIT.MANAGER_BEGIN_VIEW,
  [STAND_WORKSHEET_COLUMN_VIEW_EDIT.GRATIS_VIEW]:
    STAND_WORKSHEET_COLUMN_VIEW_EDIT.GRATIS_EDIT,
  [STAND_WORKSHEET_COLUMN_VIEW_EDIT.GRATIS_EDIT]:
    STAND_WORKSHEET_COLUMN_VIEW_EDIT.GRATIS_VIEW,
  [STAND_WORKSHEET_COLUMN_VIEW_EDIT.INGREDIENT_SPOIL_VIEW]:
    STAND_WORKSHEET_COLUMN_VIEW_EDIT.INGREDIENT_SPOIL_EDIT,
  [STAND_WORKSHEET_COLUMN_VIEW_EDIT.INGREDIENT_SPOIL_EDIT]:
    STAND_WORKSHEET_COLUMN_VIEW_EDIT.INGREDIENT_SPOIL_VIEW,
  [STAND_WORKSHEET_COLUMN_VIEW_EDIT.END_VIEW]:
    STAND_WORKSHEET_COLUMN_VIEW_EDIT.END_EDIT,
  [STAND_WORKSHEET_COLUMN_VIEW_EDIT.END_EDIT]:
    STAND_WORKSHEET_COLUMN_VIEW_EDIT.END_VIEW,
  [STAND_WORKSHEET_COLUMN_VIEW_EDIT.ADJUSTMENT_VIEW]:
    STAND_WORKSHEET_COLUMN_VIEW_EDIT.ADJUSTMENT_EDIT,
  [STAND_WORKSHEET_COLUMN_VIEW_EDIT.ADJUSTMENT_EDIT]:
    STAND_WORKSHEET_COLUMN_VIEW_EDIT.ADJUSTMENT_VIEW,
};
